import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React, { ChangeEvent, useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import {
  OverviewCard,
  PageTitleAndSubTitle,
  DashedStandardDropdown,
  Breadcrumbs,
  CostTrend,
  MultiProgressBarsChart,
  Columns,
  // PartitionCard,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import {
  CostValues,
  // formatGenderValues,
  formatMemberValues,
  getPmpmValueForCohorts,
  MemberValues,
  PMPM,
  TitleValueType,
  TotalCost,
} from '../../core-utils/helper-utils/summaryReportHelper';
import properties from '../../core-utils/properties';
import Loader from '../../_components/molecules/Loader';
import {
  downloadPdf,
  handleDownloadCSV,
} from '../../core-utils/helper-utils/downloadPdfHelper';
import diseasePrevalencePageConstants from '../../core-utils/messages/diseasePrevalencePageConstants';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { COMMON_TEXTS } from '../../core-utils/messages/CommonConstants';
import { useStores } from '../../stores';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import TabSelection from '../../_components/molecules/TabSelection';
import RecommendationsTab from '../../_components/organisms/RecommendationsTab';
import { getRecommendationsData } from '../../core-utils/helper-utils/recommendationsTabHelper';
import OverviewCardTooltipContent from '../../_components/atoms/OverviewCardTooltipContent';
import { getCohortValue } from '../../core-utils/helper-utils/overviewCardHelper';
import {
  addPrefix,
  commasForNumbers,
  numFormatterWithSuffix,
} from '../../core-utils/helper-utils/helper';
import {
  formatMemberDistAgeData,
  getPageUrl,
} from '../../core-utils/helper-utils/diseasePrevlanceHelper';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import Snackbar from '../../_components/atoms/Snackbar';
import { PATIENT_DETAILS } from '../../core-utils/routes';
import CohortDetailsModal from '../../_components/organisms/CohortDetailsModalNew';
import FeatureAccessModal from '../../_components/organisms/FeatureAccessModal';
import {
  UserAccessConstants,
  checkUserAccess,
} from '../../core-utils/helper-utils/userAccess';
// import QueryIcon from '../../_components/atoms/Icons/QueryIcon';
import { observer } from 'mobx-react';
import CustomColumnsTable from '../../_components/organisms/CustomColumnsTable';
import {
  columnsDropdownOptions,
  defaultColumns,
  formatMembersListData,
  getColumns,
} from '../../core-utils/helper-utils/customColumnsHelper';
import moment from 'moment';
// import { partitionValues } from '@HomaHealth/ui-component-library/lib/_AIQ-components/molecules/PartitionCard';
import { getInfoIcon } from '../../core-utils/helper-utils/infoIconHelper';
import { useAPIPayload } from '../../core-utils/helper-utils/apiPayloadHelper';
import DateFilter from '../../_components/molecules/DateFilter';
import useTotalEligible from '../../core-utils/custom-hooks/TotalEligible';
import { getChronicSubTitle } from '../ChronicPrevalence';
import { getDiseaseSubTitle } from '../DiseasePrevalence';
import { getStoplossSubTitle } from '../StopLossPage';
import CohortFilterBar from '../../_components/molecules/CohortFilterBar';
import { useCohortOnPageLoad } from '../../core-utils/custom-hooks/useCohortPageOnLoad';
import { useCohortModal } from '../../core-utils/custom-hooks/useCohortModal';

export type Params = {
  condition: string;
};

export interface DiseaseInternalPageProps {
  type: 'chronic' | 'disease' | 'stoploss';
}

export const titleAndSubtitles = {
  chronic: {
    title: 'Chronic Prevalence',
    subTitle: getChronicSubTitle(),
  },
  disease: {
    title: 'Disease and Condition Spend',
    subTitle: getDiseaseSubTitle(),
  },
  stoploss: {
    title: 'Stoploss Triggers',
    subTitle: getStoplossSubTitle(),
  },
};

const DiseaseInternalPage: React.FC<DiseaseInternalPageProps> = observer(
  ({ type }) => {
    const useStyles = makeStyles()({
      root: {
        display: 'flex',
        flexDirection: 'column',
        padding: '40px 0px 66px 63px',
      },
      headerText: {
        fontSize: '12px',
        fontHeight: '12px',
        fontWeight: 500,
        color: patientAccessTheme.palette.text.highemphasis,
      },

      innerRoot: {
        display: 'flex',
        flexDirection: 'column',
      },
      tableHeader: {
        height: '58px',
        backgroundColor: patientAccessTheme.palette.grey[100],
        borderTop: `1px solid ${patientAccessTheme.palette.grey[300]}`,
        borderBottom: `1px solid ${patientAccessTheme.palette.grey[300]}`,
        '&:first-child': {
          paddingLeft: '38px',
        },
        textAlign: 'left',
      },
      tableRow: {
        height: '56px',
        padding: '0px',
        borderBottom: `1px solid ${patientAccessTheme.palette.grey[300]}`,
        '&:first-child': {
          paddingLeft: '38px',
        },
      },
      queryIconGrid: {
        padding: '10px 0px 10px 22px',
      },
      queryDataOverallGrid: {
        margin: '10px 10px 10px 0px',
        height: '44px',
        backgroundColor: '#FFFFFF',
        border: '1px solid #DADEEF',
        width: '1176px',
        borderRadius: '4px',
        flexWrap: 'nowrap',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      queryDataTypography: {
        padding: '10px 10px',
        height: '44px',
        borderRight: '1px solid #DADEEF',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      queryDataGrid: {
        maxWidth: '400px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        minWidth: '60px',
      },
      editQueryGrid: {
        padding: '10px 40px',
        backgroundColor: '#FFFFFF',
        border: '1px solid #DADEEF',
      },
      tooltip: {
        backgroundColor: patientAccessTheme.palette.grey[900],
        padding: '10px',
        fontSize: '13px',
        fontFamily: 'Inter',
        fontWeight: 400,
        lineHeight: '16px',
        color: patientAccessTheme.palette.status.white,
      },
      arrow: {
        color: patientAccessTheme.palette.grey[900],
        marginLeft: '50px',
      },
      popper: {
        marginTop: '-20px',
        marginLeft: '-20px',
      },
      flex: {
        display: 'flex',
      },
    });

    const defaultSelectedColumns = [...defaultColumns, 'Primary Care'];
    const previousYearCostSortFields = [
      'previousYearCost',
      'prevMedicalCost',
      'prevRxCost',
    ];
    const pageUrl = getPageUrl(type);

    const infoIcon = getInfoIcon(
      `Top 3 Diagnosis based on Total Cost.`,
      () => {},
      {
        display: 'flex',
        alignItems: 'center',
      },
    );

    //Stores
    const employerGroupStore = useStores().employerGroupStore;
    const {
      diseasePrevalenceStore,
      chronicPrevalenceStore,
      memberSummaryStore,
    } = useStores();
    let commonStore: any;
    switch (type) {
      case 'disease':
        commonStore = diseasePrevalenceStore;
        break;
      case 'chronic':
        commonStore = chronicPrevalenceStore;
        break;
      case 'stoploss':
        commonStore = memberSummaryStore;
        break;
      default:
        commonStore = null;
    }
    const recommendedTabStore = useStores().recommendedTabStore;
    const cohortDetailsStore = useStores().cohortDetailsStore;
    const loginPageStore = useStores().loginPageStore;
    const quaterlyReportStore = useStores().quaterlyReportStore;

    //Location States
    const { condition: encodedCondition } = useParams<Params>();
    const condition =
      type === 'stoploss'
        ? memberSummaryStore.currentDisease
        : decodeURIComponent(encodedCondition ?? '');

    const isDiseaseGroup =
      type === 'chronic' || type === 'stoploss'
        ? false
        : condition?.charAt(0) !== ' ';

    const [selectedColumns, setSelectedColumns] = useState<string[]>(
      defaultSelectedColumns,
    );
    const [tableColumns, setTableColumns] = useState<Columns[]>(
      getColumns(defaultSelectedColumns, infoIcon),
    );
    const [sortField, setSortField] = useState<string>('totalCost');
    const [sortOrder, setSortOrder] = useState<number>(-1);

    const { classes } = useStyles();
    const navigate = useNavigate();

    const messages = diseasePrevalencePageConstants.DISEASE_PREVALENCE_PAGE;
    const {
      incurredStartDate,
      incurredEndDate,
      paidStartDate,
      paidEndDate,
      isIncurredDate,
      isPaidDate,
      isPlanDatesFetched,
      aggregationParameter,
    } = quaterlyReportStore;
    const payload = useAPIPayload();
    const {
      overAllEnrolled,
      overallTotalCost,
      getTotalEligible,
    } = useTotalEligible(
      aggregationParameter === 'paid' ? paidStartDate : incurredStartDate,
      aggregationParameter === 'paid' ? paidEndDate : incurredEndDate,
      employerGroupStore,
    );
    const memberList = useMemo(() => {
      if (!condition) {
        return [];
      }
      return commonStore?.diseasesMembersMap?.get(condition)?.memberList ?? [];
    }, [condition, commonStore?.diseasesMembersMap]);
    const { open, openModal, closeModal, isEditMode } = useCohortModal();
    const [openFeatureAccessModal, setOpenFeatureAccessModal] = useState(false);

    //State Variables

    //Other States

    const [loading, setLoading] = useState<boolean>(false);
    const [loader] = useState<any>(<Loader />);
    const [totalCost, setTotalCost] = useState<TotalCost>({
      totalCost: '',
      totalRx: '',
      totalMedical: '',
    });
    const [costValues, setCostValues] = useState<CostValues>({
      rx: '$0.00',
      medical: '$0.00',
      total: '$0.00',
    });
    const [memberValues, setMemberValues] = useState<MemberValues>({
      members: '0',
      employees: '0',
      dependents: '0',
    });
    const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);
    const [
      pcDistributionMemberData,
      setPcDistributionMemberData,
    ] = useState<any>([]);
    const [memberDistributionData, setMemberDistributionData] = useState<any>(
      [],
    );
    const [totalPages, setTotalPages] = useState(0);

    const [pageSize] = useState(10);
    const [pageNumber, setPageNumber] = useState(1);

    const [tableLoading, setTableLoading] = useState<boolean>(false);
    const [riskMemberListData, setRiskMemberListData] = useState<any[]>([]);

    const [
      memberDistributionLoading,
      setMemberDistributionLoading,
    ] = useState<boolean>(false);

    //Sites Of Care States
    const [
      sitesOfCareDropDownValue,
      setSitesOfCareDropDownValue,
    ] = useState<string>('Cost');
    const [sitesOfCareByCost, setSitesOfCareByCost] = useState<
      TitleValueType[]
    >([]);
    const [sitesOfCareByMember, setSitesOfCareByMember] = useState<
      TitleValueType[]
    >([]);
    const [sitesOfCareTotalPages, setSitesOfCareTotalPages] = useState<number>(
      0,
    );
    const [sitesOfCarePageNumber, setSitesOfCarePageNumber] = useState<number>(
      1,
    );
    const [sitesOfCareLoading, setSitesOfCareLoading] = useState<boolean>(
      false,
    );

    //Top Disease Prevalence States
    // const [
    //   diseasePrevalenceDropDownValue,
    //   setDiseasePrevalenceDropDownValue,
    // ] = useState<string>(type === 'chronic' ? 'Member' : 'Cost');
    // const [diseasePrevalenceByCost, setDiseasePrevalenceByCost] = useState<
    //   TitleValueType[]
    // >([]);
    const [diseasePrevalenceByMember, setDiseasePrevalenceByMember] = useState<
      TitleValueType[]
    >([]);
    const [
      diseasePrevalenceTotalPages,
      setDiseasePrevalenceTotalPages,
    ] = useState<number>(0);
    const [
      diseasePrevalencePageNumber,
      setDiseasePrevalencePageNumber,
    ] = useState<number>(1);
    const [
      diseasePrevalenceLoading,
      setDiseasePrevalenceLoading,
    ] = useState<boolean>(false);

    //Top Specialization States
    const [
      topSpecializationDropDownValue,
      setTopSpecializationDropDownValue,
    ] = useState<string>('Cost');
    const [topSpecializationByCost, setTopSpecializationByCost] = useState<
      TitleValueType[]
    >([]);
    const [
      specializationTotalPages,
      setSpecializationTotalPages,
    ] = useState<number>(0);
    const [
      specializationPageNumber,
      setSpecializationPageNumber,
    ] = useState<number>(1);
    const [topSpecializationByMember, setTopSpecializationByMember] = useState<
      TitleValueType[]
    >([]);
    const [specializationLoading, setSpecializationLoading] = useState<boolean>(
      false,
    );

    //Top Procedures States
    const [
      topProceduresDropDownValue,
      setTopProceduresDropDownValue,
    ] = useState<string>('Cost');
    const [topProceduresByCost, setTopProceduresByCost] = useState<
      TitleValueType[]
    >([]);
    const [topProceduresByMember, setTopProceduresByMember] = useState<
      TitleValueType[]
    >([]);
    const [
      topProceduresTotalPages,
      setTopProceduresTotalPages,
    ] = useState<number>(0);
    const [
      topProceduresPageNumber,
      setTopProceduresPageNumber,
    ] = useState<number>(1);
    const [topProceduresLoading, setTopProceduresLoading] = useState<boolean>(
      false,
    );

    const [recommendationLoading, setRecommendationLoading] = useState<boolean>(
      false,
    );
    const [recommendationFetched, setRecommendationFetched] = useState<boolean>(
      false,
    );
    const [clickedMember, setClickedMember] = useState<string>('');
    const [pmpm, setPMPM] = useState<PMPM>({
      pmpm: '',
      pmpmPercentage: '',
      increment: true,
    });
    const { totalResults, memberIds, isInitializing } = useCohortOnPageLoad({
      fetchTotalResults: () => getDisPrevalenceCohortMembers(),
      enabled:
        isPlanDatesFetched &&
        !!employerGroupStore?.employerGroupResponseData?.eg_nid?.[0],
      isInternal: true,
      deps: [condition],
    });

    const handleMemberClick = (value: string) => {
      setClickedMember(value);
    };

    const handleChangeColumns = () => {
      setTableColumns(getColumns(selectedColumns, infoIcon));
      getRiskMembersList();
    };

    const handleSort = (event: any, column: any, item: any) => {
      const sortOrder = item.actionType === 'ascendingSorting' ? 1 : -1;
      const { sortColumnName } = column;
      if (!sortColumnName) {
        return;
      }

      setSortField(sortColumnName);
      setSortOrder(sortOrder);
    };

    const handleExportCSV = () => {
      handleDownloadCSV(
        properties.aiqBaseUrl + properties.membersList + '/csv',
        { ...membersListRequestBody, showAll: true },
        `${type}-${condition}.csv`,
        handleOpenSnackBar,
      );
    };

    const handleSelectedIndex = (index: number) => {
      setSelectedTabIndex(index);
      if (!recommendationFetched) {
        getRecommendationsData(
          employerGroupStore?.employerGroupResponseData?.eg_nid,
          recommendedTabStore?.categoryToBeCalled,
          recommendedTabStore,
          setRecommendationLoading,
        );
        setRecommendationFetched(true);
      }
    };

    const getMemberClaims = async (memberId: string) => {
      return await axios
        .post(
          properties.aiqBaseUrl +
            properties.membersBaseUrl +
            properties.memberDetails,
          {
            eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
            paidStartDate,
            paidEndDate,
            incurredStartDate,
            incurredEndDate,
            aggregationParameter,
            member_unique_id: [memberId],
            claim_id_list: [],
          },
        )
        .then((response) => response.data);
    };

    const membersListRequestBody = {
      eg_nid: employerGroupStore.employerGroupResponseData.eg_nid,
      startYear: moment(
        aggregationParameter === 'paid' ? paidStartDate : incurredStartDate,
        'YYYY-MM-DD',
      ).year(),
      member_unique_id_list: memberList ?? [],
      pageNumber: pageNumber - 1,
      pageSize: pageSize,
      sortField: sortField,
      sortOrder: sortOrder,
      category: 'chronic',
      startDate:
        aggregationParameter === 'paid' ? paidStartDate : incurredStartDate,
      endDate: aggregationParameter === 'paid' ? paidEndDate : incurredEndDate,
      max_claim_date:
        employerGroupStore.employerGroupResponseData.max_claim_date,
      columnList: selectedColumns,
      showAll: previousYearCostSortFields?.includes(sortField),
      // drugType: 'Glucagon-like Peptide-1 (glp-1) Analogues',
      diagnosis_count: 3,
      diagnosis_sort_field: 'totalPaid',
    };

    const getRiskMembersList = async () => {
      setTableLoading(true);

      const response = await axios.post(
        properties.aiqBaseUrl + properties.membersList,
        membersListRequestBody,
      );

      if (response?.status === 200) {
        const updatedData = await Promise.all(
          response?.data?.data?.memberList?.map(async (item: any) => {
            const memberClaimsData = await getMemberClaims(item['Member ID']);
            return {
              ...item,
              claimData: memberClaimsData?.data,
            };
          }),
        );
        setRiskMemberListData(
          formatMembersListData(updatedData, selectedColumns),
        );
        setTotalPages(Math.ceil(response.data.data?.totalMembers / 10));
        setTableLoading(false);
      }
    };

    const getMemberAndClaimBody = () => {
      if (cohortDetailsStore.memberUniqueIdList.length > 0) {
        const intersection = cohortDetailsStore.memberUniqueIdList.filter(
          (value) => memberList.includes(value),
        );
        return {
          member_unique_id_list: intersection,
          claim_id_list: cohortDetailsStore.claimIdList,
        };
      }
      return {
        member_unique_id_list: memberList,
        claim_id_list: [],
      };
    };

    const getDisPrevalenceCohortMembers = async (): Promise<{
      noOfMemberIds: number;
      member_unique_ids: string[];
    }> => {
      try {
        const res = await axios.post(
          properties.aiqBaseUrl +
            properties.diseasePrevalence +
            properties.getDisPrevalenceCohortMembers,
          {
            ...payload,
            claim_id_list: [],
            member_unique_id_list: cohortDetailsStore.memberUniqueIdList || [],
            max_claim_date:
              employerGroupStore?.employerGroupResponseData?.max_claim_date,
            condition: condition,
            isDiseaseGroup: isDiseaseGroup,
            type,
          },
        );

        if (res?.status === 200) {
          const data = res?.data?.data;
          return {
            noOfMemberIds: data?.noOfMemberIds || 0,
            member_unique_ids: data?.member_unique_ids || [],
          };
        }

        return { noOfMemberIds: 0, member_unique_ids: [] };
      } catch (error) {
        console.error(error);
        return { noOfMemberIds: 0, member_unique_ids: [] };
      }
    };

    //Snackbar
    const handleOpenSnackBar = (
      message: string,
      severity: MuiColor,
      duration: number | null,
    ) => {
      setSnackbarState({
        open: true,
        message: message,
        severity: severity,
        duration: duration,
      });
    };

    const handleCloseSnackBar = (
      event?: React.SyntheticEvent,
      reason?: string,
    ) => {
      if (reason === 'clickaway') {
        return;
      }
      setSnackbarState({
        open: false,
        message: '',
        severity: undefined,
        duration: null,
      });
    };

    const [snackbarState, setSnackbarState] = React.useState<{
      open: boolean;
      message: string;
      severity: MuiColor | undefined;
      duration: null | number;
    }>({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });

    //Functions

    const handlePageChange = (event: ChangeEvent<unknown>, page: number) => {
      setPageNumber(page);
    };

    const handleSitesOfCarePageChange = (
      event: React.ChangeEvent<unknown>,
      value: number,
    ) => {
      setSitesOfCarePageNumber(value);
    };

    const handleDiseasePrevalencePageChange = (
      event: React.ChangeEvent<unknown>,
      value: number,
    ) => {
      setDiseasePrevalencePageNumber(value);
    };

    const handleSpecializationPageChange = (
      event: React.ChangeEvent<unknown>,
      value: number,
    ) => {
      setSpecializationPageNumber(value);
    };

    const handleTopProceduresPageChange = (
      event: React.ChangeEvent<unknown>,
      value: number,
    ) => {
      setTopProceduresPageNumber(value);
    };

    const reqBody = {
      startDate:
        aggregationParameter === 'paid' ? paidStartDate : incurredStartDate,
      endDate: aggregationParameter === 'paid' ? paidEndDate : incurredEndDate,
      ...getMemberAndClaimBody(),
      max_claim_date:
        employerGroupStore?.employerGroupResponseData?.max_claim_date,
      ...payload,
    };

    const diseaseReqBody = {
      type,
      // isDiseasePrevalence: type === 'disease',
      isDiseaseGroup: isDiseaseGroup,
      condition: condition,
    };

    const getTotalCost = async () => {
      try {
        const cohortCost = commonStore?.diseasesMembersMap?.get(condition);
        const totalCostValues = {
          totalCost: addPrefix(
            '$',
            numFormatterWithSuffix(
              cohortCost?.medicalCost + cohortCost?.rxCost,
              2,
            ),
          ),
          totalRx: addPrefix(
            '$',
            numFormatterWithSuffix(cohortCost?.rxCost, 2),
          ),
          totalMedical: addPrefix(
            '$',
            numFormatterWithSuffix(cohortCost?.medicalCost, 2),
          ),
        };
        setTotalCost(totalCostValues);
        const pmpmValue = addPrefix(
          '$',
          numFormatterWithSuffix(cohortCost?.pmpm, 2),
        );

        setPMPM({ ...pmpm, pmpm: pmpmValue });
        const costDataValues = {
          total:
            '$' +
            commasForNumbers(
              `${cohortCost?.medicalCost + cohortCost?.rxCost}`,
              2,
            ),
          rx: '$' + commasForNumbers(`${cohortCost?.rxCost}`, 2),
          medical: '$' + commasForNumbers(`${cohortCost?.medicalCost}`, 2),
        };
        setCostValues(costDataValues);
        const response2 = await axios.post(
          properties.aiqBaseUrl + properties.summaryBaseUrl,
          reqBody,
        );
        if (response2.status === 200) {
          setMemberValues(formatMemberValues(response2?.data?.data));
          // setAvgAge(response2?.data?.data?.avgAge ?? 0);
          // setGenderData(
          //   formatGenderValues(response2?.data?.data?.totalEnrollesCount),
          // );
        }
      } catch (ex) {
        throw ex;
      }
    };

    const getPCDistribution = async () => {
      try {
        await axios
          .post(
            properties.aiqBaseUrl +
              properties.diseasePrevalence +
              properties.pcDistribution,
            {
              ...reqBody,
              ...diseaseReqBody,
            },
          )
          .then((res) => {
            if (res?.status === 200) {
              setPcDistributionMemberData(res?.data?.data?.yesCount);
            }
          })
          .catch((ex) => {
            return ex;
          });
      } catch (ex) {
        throw ex;
      }
    };

    const getMemberDistibutionByMember = async () => {
      try {
        setMemberDistributionLoading(true);
        await axios
          .post(
            properties.aiqBaseUrl +
              properties.diseasePrevalence +
              properties.memberDistributionByMember,
            {
              ...reqBody,
              ...getMemberAndClaimBody(),
              max_claim_date:
                employerGroupStore?.employerGroupResponseData?.max_claim_date,
            },
          )
          .then((res) => {
            if (res?.status === 200) {
              const memberDistData = formatMemberDistAgeData(res?.data?.data);
              setMemberDistributionData(memberDistData);
            }
          })
          .catch((ex) => {
            return ex;
          });
        setMemberDistributionLoading(false);
      } catch (ex) {
        throw ex;
      }
    };

    const getSitesOfCareByMember = async () => {
      try {
        setSitesOfCareLoading(true);
        await axios
          .post(
            properties.aiqBaseUrl +
              properties.diseasePrevalence +
              properties.sitesOfCareByMember,
            {
              ...payload,
              ...getMemberAndClaimBody(),
              ...diseaseReqBody,
              pageNumber: sitesOfCarePageNumber - 1,
              pageSize: 5,
              max_claim_date:
                employerGroupStore?.employerGroupResponseData?.max_claim_date,
            },
          )
          .then((res) => {
            if (res?.status === 200) {
              setSitesOfCareTotalPages(
                Math.ceil(res?.data?.data?.totalCount / 5),
              );
              const formattedData = res?.data?.data?.sitesOfCareByMember.map(
                (item: any) => {
                  return {
                    title: item?.placeOfService,
                    value: item?.memberPercent.toFixed(0),
                  };
                },
              );
              setSitesOfCareByMember(formattedData);
            }
          })
          .catch((ex) => {
            return ex;
          });
        setSitesOfCareLoading(false);
      } catch (ex) {
        throw ex;
      }
    };

    const getSitesOfCareByCost = async () => {
      try {
        setSitesOfCareLoading(true);
        await axios
          .post(
            properties.aiqBaseUrl +
              properties.diseasePrevalence +
              properties.sitesOfCareByCost,
            {
              ...payload,
              ...getMemberAndClaimBody(),
              ...diseaseReqBody,
              pageNumber: sitesOfCarePageNumber - 1,
              pageSize: 5,
            },
          )
          .then((res) => {
            if (res?.status === 200) {
              setSitesOfCareTotalPages(
                Math.ceil(res?.data?.data?.totalCount / 5),
              );
              const formattedData = res?.data?.data?.sitesOfCareByCost.map(
                (item: any) => {
                  return {
                    title: item?.placeOfService,
                    value: item?.costPercent.toFixed(0),
                  };
                },
              );
              setSitesOfCareByCost(formattedData);
            }
          })
          .catch((ex) => {
            return ex;
          });
        setSitesOfCareLoading(false);
      } catch (ex) {
        throw ex;
      }
    };

    const getDiseasePrevalenceByMember = async () => {
      try {
        setDiseasePrevalenceLoading(true);
        await axios
          .post(
            properties.aiqBaseUrl +
              properties.diseasePrevalence +
              properties.diseasePrevalenceByMember,
            {
              ...payload,
              ...getMemberAndClaimBody(),
              ...diseaseReqBody,
              pageNumber: diseasePrevalencePageNumber - 1,
              max_claim_date:
                employerGroupStore?.employerGroupResponseData?.max_claim_date,
            },
          )
          .then((res) => {
            if (res?.status === 200) {
              setDiseasePrevalenceTotalPages(
                Math.ceil(res?.data?.data?.totalCount / 5),
              );
              const formattedData = res?.data?.data?.topDiagnosis.map(
                (item: any) => {
                  return {
                    title: item?.chronicDiseaseName,
                    value: item?.chronicDiseasePercent.toFixed(0),
                  };
                },
              );
              setDiseasePrevalenceByMember(formattedData);
            }
          })
          .catch((ex) => {
            return ex;
          });
        setDiseasePrevalenceLoading(false);
      } catch (ex) {
        throw ex;
      }
    };
    // const getDiseasePrevalenceByCost = async () => {
    //   try {
    //     setDiseasePrevalenceLoading(true);
    //     await axios
    //       .post(
    //         properties.aiqBaseUrl +
    //           properties.diseasePrevalence +
    //           properties.diseasePrevalenceByCost,
    //         {
    //           ...payload,
    //           ...getMemberAndClaimBody(),
    //           ...diseaseReqBody,
    //           pageNumber: diseasePrevalencePageNumber - 1,
    //         },
    //       )
    //       .then((res) => {
    //         if (res?.status === 200) {
    //           setDiseasePrevalenceTotalPages(
    //             Math.ceil(res?.data?.data?.totalCount / 5),
    //           );
    //           const formattedData = res?.data?.data?.topDiagnosis.map(
    //             (item: any) => {
    //               return {
    //                 title: item?.chronicDiseaseName,
    //                 value: item?.chronicDiseasePercent.toFixed(0),
    //               };
    //             },
    //           );
    //           setDiseasePrevalenceByCost(formattedData);
    //         }
    //       })
    //       .catch((ex) => {
    //         return ex;
    //       });
    //     setDiseasePrevalenceLoading(false);
    //   } catch (ex) {
    //     throw ex;
    //   }
    // };

    const getTopSpecializationByMember = async () => {
      try {
        setSpecializationLoading(true);
        await axios
          .post(
            properties.aiqBaseUrl +
              properties.diseasePrevalence +
              properties.topSpecializationByMember,
            {
              ...payload,
              ...getMemberAndClaimBody(),
              ...diseaseReqBody,
              pageNumber: specializationPageNumber - 1,
              pageSize: 5,
              max_claim_date:
                employerGroupStore?.employerGroupResponseData?.max_claim_date,
              diseaseName: condition,
            },
          )
          .then((res) => {
            if (res?.status === 200) {
              setSpecializationTotalPages(
                Math.ceil(res?.data?.data?.totalCount / 5),
              );
              const formattedData = res?.data?.data?.specializationByMember.map(
                (item: any) => {
                  return {
                    title: item?.specialization,
                    value: item?.memberPercent.toFixed(0),
                  };
                },
              );
              setTopSpecializationByMember(formattedData);
            }
          })
          .catch((ex) => {
            return ex;
          });
        setSpecializationLoading(false);
      } catch (ex) {
        throw ex;
      }
    };
    const getTopSpecializationByCost = async () => {
      try {
        setSpecializationLoading(true);
        await axios
          .post(
            properties.aiqBaseUrl +
              properties.diseasePrevalence +
              properties.topSpecializationByCost,
            {
              ...payload,
              ...getMemberAndClaimBody(),
              ...diseaseReqBody,
              pageNumber: specializationPageNumber - 1,
              pageSize: 5,
            },
          )
          .then((res) => {
            if (res?.status === 200) {
              setSpecializationTotalPages(
                Math.ceil(res?.data?.data?.totalCount / 5),
              );
              const formattedData = res?.data?.data?.specializationByCost.map(
                (item: any) => {
                  return {
                    title: item?.specialization,
                    value: item?.costPercent.toFixed(0),
                  };
                },
              );
              setTopSpecializationByCost(formattedData);
            }
          })
          .catch((ex) => {
            return ex;
          });
        setSpecializationLoading(false);
      } catch (ex) {
        throw ex;
      }
    };

    const getTopProceduresByMember = async () => {
      try {
        setTopProceduresLoading(true);
        await axios
          .post(
            properties.aiqBaseUrl +
              properties.diseasePrevalence +
              properties.topProceduresByMember,
            {
              ...payload,
              ...getMemberAndClaimBody(),
              ...diseaseReqBody,
              pageNumber: topProceduresPageNumber - 1,
              pageSize: 5,
              max_claim_date:
                employerGroupStore?.employerGroupResponseData?.max_claim_date,
              diseaseName: condition,
            },
          )
          .then((res) => {
            if (res?.status === 200) {
              setTopProceduresTotalPages(
                Math.ceil(res?.data?.data?.totalCount / 5),
              );
              const formattedData = res?.data?.data?.procedures.map(
                (item: any) => {
                  return {
                    title: item?.procedure,
                    value: item?.procedurePercent.toFixed(0),
                  };
                },
              );
              setTopProceduresByMember(formattedData);
            }
          })
          .catch((ex) => {
            return ex;
          });
        setTopProceduresLoading(false);
      } catch (ex) {
        throw ex;
      }
    };

    const getTopProceduresByCost = async () => {
      try {
        setTopProceduresLoading(true);
        await axios
          .post(
            properties.aiqBaseUrl +
              properties.diseasePrevalence +
              properties.topProceduresByCost,
            {
              ...payload,
              ...getMemberAndClaimBody(),
              ...diseaseReqBody,
              pageNumber: topProceduresPageNumber - 1,
              pageSize: 5,
            },
          )
          .then((res) => {
            if (res?.status === 200) {
              setTopProceduresTotalPages(
                Math.ceil(res?.data?.data?.totalCount / 5),
              );
              const formattedData = res?.data?.data?.procedures.map(
                (item: any) => {
                  return {
                    title: item?.procedure,
                    value: item?.procedurePercent.toFixed(0),
                  };
                },
              );
              setTopProceduresByCost(formattedData);
            }
          })
          .catch((ex) => {
            return ex;
          });
        setTopProceduresLoading(false);
      } catch (ex) {
        throw ex;
      }
    };

    const getSitesOfCare = () =>
      sitesOfCareDropDownValue === 'Cost'
        ? getSitesOfCareByCost()
        : getSitesOfCareByMember();

    const getTopSpecialization = () =>
      topSpecializationDropDownValue === 'Cost'
        ? getTopSpecializationByCost()
        : getTopSpecializationByMember();

    const getTopProcedures = () =>
      topProceduresDropDownValue === 'Cost'
        ? getTopProceduresByCost()
        : getTopProceduresByMember();

    const getAllCharts = async () => {
      try {
        setLoading(true);

        if (!isPlanDatesFetched || memberList.length === 0) {
          return;
        }

        await Promise.all([
          getTotalCost(),
          getPCDistribution(),
          getMemberDistibutionByMember(),
          getRiskMembersList(),
          getTotalEligible(),
          getSitesOfCare(),
          getDiseasePrevalenceByMember(),
          getTopSpecialization(),
          getTopProcedures(),
        ]);
      } finally {
        setLoading(false);
      }
    };

    useEffect(() => {
      if (clickedMember) {
        memberSummaryStore.setPathDetails([
          [
            'text',
            titleAndSubtitles[type]?.title,
            {
              color: patientAccessTheme.palette.primary[500],
              fontWeight: 500,
            },
          ],
        ]);
        navigate(PATIENT_DETAILS);
      }
    }, [clickedMember]);

    useEffect(() => {
      if (!isPlanDatesFetched || memberList.length === 0) {
        return;
      }
      if (isInitializing) {
        return;
      }
      getAllCharts();
    }, [
      isInitializing,
      isPlanDatesFetched,
      isIncurredDate,
      isPaidDate,
      incurredStartDate,
      incurredEndDate,
      paidStartDate,
      paidEndDate,
      aggregationParameter,
      cohortDetailsStore.conditionsDetails,
      memberList,
    ]);

    useEffect(() => {
      if (!isPlanDatesFetched || memberList.length === 0) {
        return;
      }

      getRiskMembersList();
    }, [pageNumber]);

    useEffect(() => {
      if (!isPlanDatesFetched || memberList.length === 0) {
        return;
      }
      getSitesOfCare();
    }, [sitesOfCarePageNumber, sitesOfCareDropDownValue]);

    useEffect(() => {
      if (!isPlanDatesFetched || memberList.length === 0) {
        return;
      }

      // diseasePrevalenceDropDownValue === 'Cost'
      //   ? getDiseasePrevalenceByCost()
      //   : getDiseasePrevalenceByMember();
      getDiseasePrevalenceByMember();
    }, [diseasePrevalencePageNumber]);

    useEffect(() => {
      if (!isPlanDatesFetched || memberList.length === 0) {
        return;
      }

      getTopSpecialization();
    }, [specializationPageNumber, topSpecializationDropDownValue]);

    useEffect(() => {
      if (!isPlanDatesFetched || memberList.length === 0) {
        return;
      }

      getTopProcedures();
    }, [topProceduresPageNumber, topProceduresDropDownValue]);

    return (
      <>
        {loading || isInitializing ? (
          loader
        ) : (
          <Grid container className={classes.root}>
            <Grid
              style={{
                marginBottom: '18px',
                width: '1182px',
              }}
            >
              <Grid style={{ marginBottom: '19px' }}>
                <Breadcrumbs
                  itemList={[
                    [
                      'text',
                      titleAndSubtitles[type]?.title,
                      {
                        color: patientAccessTheme.palette.primary[500],
                        fontWeight: 500,
                      },
                      () => {
                        navigate(`/${pageUrl}`);
                      },
                    ],
                    [
                      'text',
                      condition,
                      {
                        color: patientAccessTheme.palette.text.highemphasis,
                        fontWeight: 600,
                      },
                    ],
                  ]}
                />
              </Grid>
              <Grid style={{ position: 'relative' }}>
                <PageTitleAndSubTitle
                  title={
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Typography
                          fontSize="18px"
                          lineHeight="22px"
                          fontType="semiBold"
                          textColor={
                            patientAccessTheme.palette.text.highemphasis
                          }
                          margin="0px 8px 0px 0px"
                        >
                          {messages.PREVALENCE_BY}
                        </Typography>
                        <DashedStandardDropdown
                          options={commonStore?.diseasesDropDownList || []}
                          displayValue={commonStore?.diseasesDropDownList || []}
                          value={condition}
                          handleChange={(e: any) => {
                            const selectedDisease = e.target.value;
                            if (
                              !selectedDisease ||
                              selectedDisease === condition
                            ) {
                              return;
                            }
                            if (type === 'stoploss') {
                              memberSummaryStore.setCurrentDisease(
                                selectedDisease,
                              );
                            } else {
                              navigate(
                                `/${pageUrl}/${encodeURIComponent(
                                  selectedDisease,
                                )}`,
                              );
                            }
                          }}
                        />
                      </div>

                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          marginLeft: '8px',
                        }}
                      >
                        <Typography
                          fontSize="17px"
                          lineHeight="21px"
                          textColor={
                            patientAccessTheme.palette.text.mediumemphasis
                          }
                          fontType="semiBold"
                          margin="0px 8px"
                        >
                          {COMMON_TEXTS.FOR}
                        </Typography>

                        <DateFilter />
                      </div>
                    </div>
                  }
                  subTitle={titleAndSubtitles[type]?.subTitle}
                  showDownloadButton={false}
                  downloadButtonAction={() =>
                    downloadPdf(
                      'individualDiseaseReport',
                      {
                        startDate:
                          aggregationParameter === 'paid'
                            ? paidStartDate
                            : incurredStartDate,
                        endDate:
                          aggregationParameter === 'paid'
                            ? paidEndDate
                            : incurredEndDate,
                        eg_nid:
                          employerGroupStore?.employerGroupResponseData?.eg_nid,
                        employer:
                          employerGroupStore?.employerGroupResponseData
                            ?.employer_group_name,
                        disease: condition,
                        member_unique_id_list: memberList,
                        maxClaimDate:
                          employerGroupStore?.employerGroupResponseData
                            ?.max_claim_date,
                        isDiseaseGroup: isDiseaseGroup,
                        isDiseasePrevalence: type === 'disease',
                      },
                      handleCloseSnackBar,
                      'open',
                    )
                  }
                  showQueryDataButton={checkUserAccess(
                    UserAccessConstants.COHORT_DETAILS,
                    loginPageStore.userResponse.role.name,
                    loginPageStore.userFeatures,
                  )}
                  queryButtonText={
                    cohortDetailsStore.cohortDetailsList?.length > 0 &&
                    cohortDetailsStore.cohortDetailsList[0].category !== ''
                      ? 'Edit Cohort'
                      : 'Add Cohort'
                  }
                  queryDataAction={() => {
                    if (
                      checkUserAccess(
                        UserAccessConstants.COHORT_DETAILS,
                        loginPageStore.userResponse.role.name,
                        loginPageStore.userFeatures,
                      )
                    ) {
                      openModal();
                    }
                  }}
                />
              </Grid>
              <TabSelection
                selectedTabIndex={selectedTabIndex}
                setSelectedTabIndex={handleSelectedIndex}
                recommendationFetched={recommendationFetched}
              />
            </Grid>

            <Grid>
              {selectedTabIndex === 0 && (
                <Grid container className={classes.innerRoot}>
                  <Grid style={{ width: '1182px' }}>
                    <CohortFilterBar />
                  </Grid>
                  <Grid style={{ display: 'flex', marginBottom: '29px' }}>
                    <Grid style={{ marginRight: '24px' }}>
                      <OverviewCardTooltipContent
                        type="member"
                        cohortMemberValues={memberValues}
                        totalMemberValues={{
                          members: overAllEnrolled.totalCount,
                          employees: overAllEnrolled.employees,
                          dependents: overAllEnrolled.dependents,
                        }}
                        overviewCard={
                          <OverviewCard
                            title={messages.SUMMARY_CARDS.MEMBERS}
                            value={getCohortValue(
                              memberValues.members,
                              overAllEnrolled.totalCount,
                            )}
                            rootStyles={{
                              width: '180px',
                              fontWeight: 600,
                              fontSize: ' 24px',
                              height: '106px',
                            }}
                          />
                        }
                      />
                    </Grid>
                    <Grid style={{ marginRight: '24px' }}>
                      <OverviewCardTooltipContent
                        type="cost"
                        cohortCostValues={costValues}
                        totalCostValues={{
                          rx: overallTotalCost.totalRx,
                          medical: overallTotalCost.totalMedical,
                          total: overallTotalCost.totalCost,
                        }}
                        overviewCard={
                          <OverviewCard
                            title={messages.SUMMARY_CARDS.TOTAL_COST}
                            value={getCohortValue(
                              (totalCost?.totalCost).toString(),
                              overallTotalCost.totalCost,
                            )}
                            rootStyles={{
                              width: '300px',
                              height: '106px',
                            }}
                            labelsMinWidth="72px"
                          />
                        }
                      />
                    </Grid>
                    <Grid style={{ marginRight: '24px' }}>
                      <OverviewCard
                        title={messages.SUMMARY_CARDS.PMPM}
                        // topLabelValues={getPmpmForCohorts(pmpm, [], [])}
                        value={getPmpmValueForCohorts(pmpm, [], [])}
                        rootStyles={{
                          width: '238px',
                          height: '100px',
                        }}
                      />
                    </Grid>
                    <Grid style={{ marginRight: '24px' }}>
                      <OverviewCard
                        title={messages.SUMMARY_CARDS.PC_DISTRIBUTION_MEMBER}
                        value={getCohortValue(
                          pcDistributionMemberData.toString(),
                          memberValues.members,
                        )}
                        rootStyles={{
                          width: '220px',
                          height: '106px',
                        }}
                      />
                    </Grid>
                    {/* <Grid style={{ marginRight: '24px' }}>
                      <OverviewCard
                        title={messages.SUMMARY_CARDS.AVG_AGE}
                        value={
                          <Typography
                            fontSize="20px"
                            lineHeight="43px"
                            textColor={
                              patientAccessTheme.palette.text.highemphasis
                            }
                            fontType="medium"
                            margin="0px 4px 0px 0px"
                          >
                            {avgAge?.toFixed(2)}
                          </Typography>
                        }
                        rootStyles={{
                          width: '140px',
                          height: '106px',
                          fontWeight: 600,
                          fontSize: ' 24px',
                        }}
                      />
                    </Grid>
                    <Grid style={{ marginRight: '24px' }}>
                      <PartitionCard
                        title={messages.SUMMARY_CARDS.GENDER_TITLE}
                        values={genderData}
                        rootStyles={{
                          width: '340px',
                          height: '106px',
                          fontWeight: 600,
                          fontSize: ' 24px',
                        }}
                        showClickHere={true}
                      />
                    </Grid> */}
                  </Grid>
                  <Grid style={{ display: 'flex', marginBottom: '28px' }}>
                    <Grid style={{ marginRight: '24px' }}>
                      <MultiProgressBarsChart
                        title={messages.TOP_PROCEDURES.TITLE}
                        subTitle={`${messages.TOP_PROCEDURES.SUBTITLE}${
                          topProceduresDropDownValue === 'Member'
                            ? 'member volume '
                            : 'cost'
                        }`}
                        dataArray={
                          topProceduresDropDownValue === 'Cost'
                            ? topProceduresByCost
                            : topProceduresByMember
                        }
                        valueSuffix="%"
                        showPagination={true}
                        pageIndex={topProceduresPageNumber}
                        totalPages={topProceduresTotalPages}
                        handlePageChange={handleTopProceduresPageChange}
                        dropdownElement={
                          <DashedStandardDropdown
                            height="24px"
                            value={topProceduresDropDownValue}
                            options={messages.TOP_PROCEDURES.DROPDOWN_OPTIONS}
                            displayValue={
                              messages.TOP_PROCEDURES.DROPDOWN_OPTIONS
                            }
                            handleChange={(event: any) => {
                              const value: string = event.target
                                .value as string;
                              setTopProceduresDropDownValue(value);
                              setTopProceduresPageNumber(1);
                            }}
                          />
                        }
                        height="385px"
                        isLoading={topProceduresLoading}
                      />
                    </Grid>
                    <Grid style={{ marginRight: '24px' }}>
                      <MultiProgressBarsChart
                        title={`${messages.DISEASE_PREVALENCE.TITLE} Member`}
                        subTitle={`${messages.DISEASE_PREVALENCE.SUBTITLE} by member volume`}
                        dataArray={
                          // diseasePrevalenceDropDownValue === 'Cost'
                          //   ? diseasePrevalenceByCost
                          //   : diseasePrevalenceByMember
                          diseasePrevalenceByMember
                        }
                        valueSuffix="%"
                        showPagination={true}
                        pageIndex={diseasePrevalencePageNumber}
                        totalPages={diseasePrevalenceTotalPages}
                        handlePageChange={handleDiseasePrevalencePageChange}
                        // dropdownElement={
                        //   <DashedStandardDropdown
                        //     height="24px"
                        //     value={diseasePrevalenceDropDownValue}
                        //     options={
                        //       type === 'chronic'
                        //         ? ['Member']
                        //         : messages.DISEASE_PREVALENCE.DROPDOWN_OPTIONS
                        //     }
                        //     displayValue={
                        //       type === 'chronic'
                        //         ? ['Member']
                        //         : messages.DISEASE_PREVALENCE.DROPDOWN_OPTIONS
                        //     }
                        //     handleChange={(
                        //       event: any,
                        //     ) => {
                        //       const value: string = event.target
                        //         .value as string;
                        //       setDiseasePrevalenceDropDownValue(value);
                        //       setDiseasePrevalencePageNumber(1);
                        //     }}
                        //   />
                        // }
                        height="385px"
                        isLoading={diseasePrevalenceLoading}
                      />
                    </Grid>
                    <Grid>
                      <MultiProgressBarsChart
                        title={messages.TOP_SPECIALIZATION.TITLE}
                        subTitle={`${messages.TOP_SPECIALIZATION.SUBTITLE}${
                          topSpecializationDropDownValue === 'Member'
                            ? 'member volume '
                            : 'cost'
                        }`}
                        dataArray={
                          topSpecializationDropDownValue === 'Cost'
                            ? topSpecializationByCost
                            : topSpecializationByMember
                        }
                        valueSuffix="%"
                        showPagination={true}
                        pageIndex={specializationPageNumber}
                        totalPages={specializationTotalPages}
                        handlePageChange={handleSpecializationPageChange}
                        dropdownElement={
                          <DashedStandardDropdown
                            height="24px"
                            value={topSpecializationDropDownValue}
                            options={
                              messages.TOP_SPECIALIZATION.DROPDOWN_OPTIONS
                            }
                            displayValue={
                              messages.TOP_SPECIALIZATION.DROPDOWN_OPTIONS
                            }
                            handleChange={(event: any) => {
                              const value: string = event.target
                                .value as string;
                              setTopSpecializationDropDownValue(value);
                              setSpecializationPageNumber(1);
                            }}
                          />
                        }
                        height="385px"
                        isLoading={specializationLoading}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    id="member-details"
                    style={{ display: 'flex', marginBottom: '28px' }}
                  >
                    <CustomColumnsTable
                      title={
                        <Grid className={classes.flex}>
                          <Typography
                            fontSize="16px"
                            lineHeight="24px"
                            textColor={
                              patientAccessTheme.palette.text.highemphasis
                            }
                            fontType="semiBold"
                            margin="2px 8px 0px 0px"
                          >
                            Member Details
                          </Typography>
                        </Grid>
                      }
                      subTitle={'View the details of members'}
                      options={[...columnsDropdownOptions, 'Primary Care']}
                      mandateOptions={['Member ID']}
                      selectedItems={[...selectedColumns]}
                      setSelectedItems={setSelectedColumns}
                      handleChangeColumns={handleChangeColumns}
                      handleExport={handleExportCSV}
                      columns={tableColumns}
                      rowsData={riskMemberListData}
                      tableLoading={tableLoading}
                      handleMemberClick={handleMemberClick}
                      handleSort={handleSort}
                      totalPages={totalPages}
                      handlePageChange={handlePageChange}
                      pageNumber={pageNumber}
                    />
                  </Grid>
                  <Grid style={{ display: 'flex', marginBottom: '28px' }}>
                    <Grid style={{ marginRight: '24px' }}>
                      <CostTrend
                        showDBIcon={false}
                        chartTitle={messages.MEMBER_DISTRIBUTION.TITLE1}
                        chartSubTitle={messages.MEMBER_DISTRIBUTION.SUBTITLE}
                        showClickHere={false}
                        cardWidth={'778px'}
                        rightLabeledValues={
                          memberDistributionData?.rightLabeledValues
                        }
                        datasetProp={memberDistributionData?.formattedData}
                        chartWidth={'750'}
                        xAxisTitle={'Age'}
                        yAxisTitle={'Members'}
                        sAxisTitle={' '}
                        spaceBetweenTitleAndChart={'20px'}
                        chartType={'stackedcolumn2d'}
                        isLoading={memberDistributionLoading}
                        xAxisValues={memberDistributionData?.xAxis}
                      />
                    </Grid>
                    <Grid>
                      <MultiProgressBarsChart
                        title={messages.SITES_OF_CARE.TITLE}
                        subTitle={`${messages.SITES_OF_CARE.SUB_TITLE}${
                          sitesOfCareDropDownValue === 'Member'
                            ? 'member volume '
                            : 'cost'
                        }`}
                        dataArray={
                          sitesOfCareDropDownValue === 'Cost'
                            ? sitesOfCareByCost
                            : sitesOfCareByMember
                        }
                        valueSuffix="%"
                        showPagination={true}
                        pageIndex={sitesOfCarePageNumber}
                        totalPages={sitesOfCareTotalPages}
                        handlePageChange={handleSitesOfCarePageChange}
                        dropdownElement={
                          <DashedStandardDropdown
                            height="24px"
                            value={sitesOfCareDropDownValue}
                            options={messages.SITES_OF_CARE.DROPDOWN_OPTIONS}
                            displayValue={
                              messages.SITES_OF_CARE.DROPDOWN_OPTIONS
                            }
                            handleChange={(event: any) => {
                              const value: string = event.target
                                .value as string;
                              setSitesOfCareDropDownValue(value);
                              setSitesOfCarePageNumber(1);
                            }}
                          />
                        }
                        height="385px"
                        isLoading={sitesOfCareLoading}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              )}
              {selectedTabIndex === 1 && (
                <RecommendationsTab
                  recommendationLoading={recommendationLoading}
                  isInternalPage={true}
                />
              )}
            </Grid>
            <Snackbar
              {...snackbarState}
              handleClose={handleCloseSnackBar}
              vertical="bottom"
              horizontal="right"
            />
            <CohortDetailsModal
              open={open}
              handleClose={closeModal}
              totalResults={totalResults}
              isEditMode={isEditMode}
              existingMemberUniqueIds={memberIds}
            />
            <FeatureAccessModal
              open={openFeatureAccessModal}
              handleClose={() => {
                setOpenFeatureAccessModal(false);
              }}
              access={checkUserAccess(
                UserAccessConstants.COHORT_DETAILS,
                loginPageStore.userResponse.role.name,
                loginPageStore.userFeatures,
              )}
            ></FeatureAccessModal>
          </Grid>
        )}
      </>
    );
  },
);

export default DiseaseInternalPage;
